import {
  graphicHeaderDefaults,
  standardHeaderDefaults,
} from 'factories/header';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const getHeaderElement = (blocks, element) => {
  return element ? blocks[element.id] : {};
};

const reRenderSelector = (prev, next) => {
  if (window.dev()) {
    return next !== prev;
  }

  return true;
};

export const useHeader = () => {
  const header = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.header);
  }, reRenderSelector);

  const standardHeader = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.standardHeader);
  }, reRenderSelector);

  const graphicHeader = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.graphicHeader);
  }, reRenderSelector);

  const standardHeaderLogo = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.standardHeaderLogo);
  }, reRenderSelector);

  const graphicHeaderBackground = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.graphicHeaderBackground);
  }, reRenderSelector);

  const graphicHeaderLogo = useSelector((state: State) => {
    return getHeaderElement(state.blocks, state.graphicHeaderLogo);
  }, reRenderSelector);

  return {
    block: header,
    props: {
      headerStyle: 'standard',
      ...header?.props,
    },

    standard: {
      block: standardHeader,
      props: {
        ...standardHeaderDefaults,
        ...standardHeader?.props,
        headerLogo: standardHeaderLogo?.props?.src,
      },
      logoBlock: standardHeaderLogo,
    },
    graphic: {
      block: graphicHeader,
      props: {
        ...graphicHeaderDefaults,
        ...graphicHeader?.props,
        headerBackgroundImage: graphicHeaderBackground?.props?.src,
        headerLogo: graphicHeaderLogo?.props?.src,
      },
      backgroundBlock: graphicHeaderBackground,
      logoBlock: graphicHeaderLogo,
    },
  } as any;
};
